import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
export default class NorDaLehoiaGame extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "hasStarted", false);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "roundId", '');
    _defineProperty(this, "items", []);
    _defineProperty(this, "candidates", []);
    _defineProperty(this, "currentIndex", 0);
    _defineProperty(this, "playerStates", []);
    // Timer
    _defineProperty(this, "timerSeconds", 0);
    _defineProperty(this, "timerInterval", null);
    // Results
    _defineProperty(this, "isFinished", false);
    _defineProperty(this, "results", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.fetchNewRound();
  }
  onremove(vnode) {
    this.stopTimer();
    super.onremove(vnode);
  }
  startTimer() {
    this.stopTimer();
    this.timerSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.timerSeconds++;
      m.redraw();
    }, 1000);
  }
  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
  fetchNewRound() {
    this.loading = true;
    this.hasStarted = false;
    this.submitting = false;
    this.isFinished = false;
    this.results = null;
    this.currentIndex = 0;
    this.stopTimer();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/nor-da-lehoia/round'
    }).then(response => {
      this.roundId = response.round_id || '';
      this.items = response.items || [];
      this.candidates = response.candidates || [];
      this.playerStates = this.items.map(() => ({
        cluesRevealed: 1,
        // Start with 1 clue revealed
        selectedCandidate: null,
        isAnswered: false,
        isCorrect: false,
        pointsEarned: 0,
        skipped: false,
        searchQuery: '',
        dropdownOpen: false,
        attempts: [],
        feedbackAlert: null
      }));
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar los leones misteriosos. Inténtalo de nuevo.');
      m.redraw();
    });
  }
  startGame() {
    this.hasStarted = true;
    this.startTimer();
    m.redraw();
  }
  revealNextClue() {
    const state = this.playerStates[this.currentIndex];
    if (!state || state.isAnswered) return;
    if (state.cluesRevealed < 5) {
      state.cluesRevealed++;
      state.feedbackAlert = {
        type: 'info',
        message: "\uD83D\uDCA1 Pista ".concat(state.cluesRevealed, " desbloqueada. M\xE1ximo ahora: ").concat(NorDaLehoiaGame.POINTS_MAP[state.cluesRevealed], " pts.")
      };
      m.redraw();
    }
  }
  selectCandidate(candidate) {
    const state = this.playerStates[this.currentIndex];
    if (!state || state.isAnswered) return;
    state.selectedCandidate = candidate;
    state.searchQuery = candidate.name;
    state.dropdownOpen = false;
    m.redraw();
  }
  tryGuess() {
    const currentItem = this.items[this.currentIndex];
    const state = this.playerStates[this.currentIndex];
    if (!currentItem || !state || state.isAnswered) return;
    const candidate = state.selectedCandidate;
    if (!candidate) return;
    const isMatch = candidate.id === currentItem.target_id;
    const clueNumber = state.cluesRevealed;
    const attempt = {
      id: candidate.id,
      name: candidate.name,
      photo_url: candidate.photo_url || '',
      clue_number: clueNumber,
      is_correct: isMatch
    };
    state.attempts.push(attempt);
    if (isMatch) {
      state.isAnswered = true;
      state.isCorrect = true;
      state.pointsEarned = NorDaLehoiaGame.POINTS_MAP[clueNumber] || 40;
      state.cluesRevealed = 5; // Reveal all clues on success
      state.feedbackAlert = {
        type: 'success',
        message: "\xA1Correcto! Es ".concat(currentItem.target_name, " (+").concat(state.pointsEarned, " pts)")
      };
      state.dropdownOpen = false;
    } else {
      // Wrong guess
      if (state.cluesRevealed < 5) {
        state.cluesRevealed++;
        state.feedbackAlert = {
          type: 'error',
          message: "\u274C No es ".concat(candidate.name, ". \xA1Se ha desbloqueado la pista ").concat(state.cluesRevealed, "!")
        };
        // Clear input so player can type next candidate
        state.selectedCandidate = null;
        state.searchQuery = '';
        state.dropdownOpen = false;
      } else {
        // Failed on 5th clue
        state.isAnswered = true;
        state.isCorrect = false;
        state.pointsEarned = 0;
        state.feedbackAlert = {
          type: 'error',
          message: "\u274C No es ".concat(candidate.name, ". \xA1Has agotado las pistas! El le\xF3n era ").concat(currentItem.target_name, ".")
        };
        state.selectedCandidate = null;
        state.searchQuery = '';
        state.dropdownOpen = false;
      }
    }
    m.redraw();
  }
  skipCurrentPlayer() {
    const state = this.playerStates[this.currentIndex];
    if (state && !state.isAnswered) {
      state.skipped = true;
    }
    const nextPending = this.findNextPendingOrSkippedIndex(this.currentIndex);
    if (nextPending !== -1) {
      this.currentIndex = nextPending;
    }
    m.redraw();
  }
  findNextPendingOrSkippedIndex(fromIndex) {
    for (let i = fromIndex + 1; i < this.items.length; i++) {
      if (!this.playerStates[i].isAnswered) {
        return i;
      }
    }
    for (let i = 0; i <= fromIndex; i++) {
      if (!this.playerStates[i].isAnswered) {
        return i;
      }
    }
    return -1;
  }
  goToNextPending() {
    const nextIdx = this.findNextPendingOrSkippedIndex(this.currentIndex);
    if (nextIdx !== -1) {
      this.currentIndex = nextIdx;
      m.redraw();
    }
  }
  goToPlayer(idx) {
    if (idx >= 0 && idx < this.items.length) {
      this.currentIndex = idx;
      m.redraw();
    }
  }
  allPlayersAnswered() {
    return this.playerStates.length > 0 && this.playerStates.every(s => s.isAnswered);
  }
  submitRound() {
    if (this.submitting || this.isFinished) return;
    this.submitting = true;
    this.stopTimer();
    const payloadAnswers = this.items.map((item, idx) => {
      const st = this.playerStates[idx];
      const winningAttempt = st.attempts.find(a => a.is_correct);
      const lastAttempt = st.attempts[st.attempts.length - 1];
      return {
        key: item.key,
        player_id: st.isCorrect ? item.target_id : lastAttempt ? lastAttempt.id : null,
        clues_used: st.isCorrect ? winningAttempt ? winningAttempt.clue_number : st.cluesRevealed : 5,
        attempts: st.attempts
      };
    });
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/nor-da-lehoia/submit',
      body: {
        round_id: this.roundId,
        answers: payloadAnswers,
        duration_seconds: this.timerSeconds
      }
    }).then(response => {
      this.submitting = false;
      this.isFinished = true;
      this.results = response;
      m.redraw();
    }).catch(err => {
      this.submitting = false;
      const msg = err && err.response && err.response.error || 'Error al enviar tus resultados.';
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  formatTimer(seconds) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return "".concat(m, ":").concat(s < 10 ? '0' : '').concat(s);
  }
  getFilteredCandidates(query) {
    if (!query.trim()) {
      return this.candidates.slice(0, 8);
    }
    const cleanQuery = this.normalizeStr(query);
    return this.candidates.filter(c => this.normalizeStr(c.name).includes(cleanQuery) || String(c.number) === query.trim()).slice(0, 10);
  }
  normalizeStr(str) {
    return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  view() {
    try {
      if (this.loading) {
        return m("div", {
          className: "nor-da-lehoia-game loading-state"
        }, m(LoadingIndicator, null), m("p", null, "Cargando leones misteriosos..."));
      }
      if (this.isFinished && this.results) {
        return this.renderResults();
      }
      if (!this.hasStarted) {
        return this.renderWelcome();
      }
      return this.renderGameScreen();
    } catch (e) {
      console.error('NorDaLehoiaGame render error:', e);
      return m("div", {
        className: "nor-da-lehoia-game error-state",
        style: {
          padding: '30px',
          textAlign: 'center'
        }
      }, m("p", null, "Ocurri\xF3 un error al cargar la partida."), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.fetchNewRound()
      }, "Reintentar"));
    }
  }
  renderWelcome() {
    return m("div", {
      className: "nor-da-lehoia-game welcome-card"
    }, m("div", {
      className: "welcome-hero"
    }, m("span", {
      className: "welcome-emoji"
    }, "\uD83E\uDD81\uD83D\uDD0D"), m("h2", null, "Nor da Lehoia?"), m("p", {
      className: "welcome-desc"
    }, "Adivina qu\xE9 le\xF3n del Athletic se oculta tras las pistas de su ficha oficial. Prueba tus opciones pista a pista: si fallas, se desbloquea la siguiente y se guardan tus intentos.")), m("div", {
      className: "welcome-rules-grid"
    }, m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83D\uDCA1"), m("div", null, m("strong", null, "Pistas progresivas"), m("p", null, "Lugar de nacimiento, demarcaci\xF3n, a\xF1o/edad, altura y dorsal de camiseta."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\uD83C\uDFAF"), m("div", null, m("strong", null, "Prueba en cada pista"), m("p", null, "Prueba un jugador con cada pista. Te dice al instante si aciertas o fallas."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\u2B50"), m("div", null, m("strong", null, "Puntuaci\xF3n por acierto"), m("p", null, "1\xAA pista: 200 pts | 2\xAA: 150 pts | 3\xAA: 100 pts | 4\xAA: 70 pts | 5\xAA: 40 pts."))), m("div", {
      className: "rule-item"
    }, m("div", {
      className: "rule-icon"
    }, "\u23F1\uFE0F"), m("div", null, m("strong", null, "Tiempo y r\xE9cord"), m("p", null, "15s de cortes\xEDa sin penalizaci\xF3n; despu\xE9s -1 pt por segundo transcurrido.")))), m("div", {
      className: "welcome-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block btn-start-game",
      icon: "fas fa-play",
      onclick: () => this.startGame()
    }, "\xA1Comenzar Tanda!")));
  }
  renderGameScreen() {
    const currentItem = this.items[this.currentIndex];
    const currentState = this.playerStates[this.currentIndex];
    if (!currentItem || !currentState) return null;
    const currentPoints = NorDaLehoiaGame.POINTS_MAP[currentState.cluesRevealed] || 40;
    const allDone = this.allPlayersAnswered();
    const answeredCount = this.playerStates.filter(s => s.isAnswered).length;
    const filteredCandidates = currentState.dropdownOpen ? this.getFilteredCandidates(currentState.searchQuery) : [];
    return m("div", {
      className: "nor-da-lehoia-game play-screen"
    }, m("div", {
      className: "game-top-bar"
    }, m("div", {
      className: "match-stepper"
    }, this.items.map((item, idx) => {
      const isSelected = idx === this.currentIndex;
      const st = this.playerStates[idx];
      let statusClass = 'pending';
      if (isSelected) {
        statusClass = 'active';
      } else if (st.isAnswered && st.isCorrect) {
        statusClass = 'completed';
      } else if (st.isAnswered && !st.isCorrect) {
        statusClass = 'wrong';
      } else if (st.skipped) {
        statusClass = 'skipped';
      }
      return m("button", {
        type: "button",
        className: "stepper-pill ".concat(statusClass),
        onclick: () => this.goToPlayer(idx),
        title: "Le\xF3n ".concat(idx + 1)
      }, m("span", {
        className: "step-num"
      }, idx + 1), st.isAnswered && st.isCorrect && m("i", {
        className: "fas fa-check step-icon"
      }), st.isAnswered && !st.isCorrect && m("i", {
        className: "fas fa-times step-icon"
      }), !st.isAnswered && st.skipped && m("i", {
        className: "fas fa-forward step-icon"
      }));
    })), m("div", {
      className: "game-timer-badge"
    }, m("i", {
      className: "far fa-clock"
    }), m("span", null, this.formatTimer(this.timerSeconds)))), m("div", {
      className: "mystery-player-card"
    }, m("div", {
      className: "player-card-header"
    }, m("span", {
      className: "player-number-label"
    }, "\uD83E\uDD81 Le\xF3n ", this.currentIndex + 1, " de ", this.items.length), !currentState.isAnswered ? m("span", {
      className: "points-potential-badge"
    }, "\u2B50 ", currentPoints, " pts en juego (Pista ", currentState.cluesRevealed, ")") : currentState.isCorrect ? m("span", {
      className: "badge-answered correct"
    }, m("i", {
      className: "fas fa-check-circle"
    }), " \xA1Acertado! (+", currentState.pointsEarned, " pts)") : m("span", {
      className: "badge-answered wrong"
    }, m("i", {
      className: "fas fa-times-circle"
    }), " No acertado (0 pts)")), !currentState.isAnswered ? m("div", {
      className: "mystery-silhouette-banner"
    }, m("div", {
      className: "mystery-avatar-circle"
    }, m("span", {
      className: "mystery-icon"
    }, "\uD83E\uDD81"), m("span", {
      className: "mystery-question-mark"
    }, "?")), m("div", {
      className: "mystery-title"
    }, m("h3", null, "\xBFQui\xE9n es este le\xF3n?"), m("p", null, "Prueba con un jugador en esta pista o pide la siguiente."))) : m("div", {
      className: "revealed-player-banner ".concat(currentState.isCorrect ? 'is-correct' : 'is-wrong')
    }, m("div", {
      className: "revealed-avatar-wrapper"
    }, currentItem.target_photo ? m("img", {
      src: currentItem.target_photo,
      alt: currentItem.target_name,
      className: "revealed-player-img"
    }) : m("div", {
      className: "revealed-player-placeholder"
    }, "\uD83E\uDD81"), m("span", {
      className: "revealed-status-badge"
    }, currentState.isCorrect ? '✅' : '❌')), m("div", {
      className: "revealed-title"
    }, m("h3", null, currentItem.target_name), m("p", null, currentState.isCorrect ? "\xA1Bien visto! Acertaste con ".concat(currentState.attempts.length, " ").concat(currentState.attempts.length === 1 ? 'intento' : 'intentos', " (+").concat(currentState.pointsEarned, " pts).") : 'Agotaste las pistas disponibles sin dar con él.'))), m("div", {
      className: "clues-container"
    }, currentItem.clues.map((clue, idx) => {
      const isRevealed = idx < currentState.cluesRevealed;
      const pointsAfterThis = NorDaLehoiaGame.POINTS_MAP[idx + 1] || 40;
      return m("div", {
        className: "clue-box ".concat(isRevealed ? 'is-revealed' : 'is-locked')
      }, m("div", {
        className: "clue-header"
      }, m("span", {
        className: "clue-label"
      }, clue.label), !isRevealed ? m("span", {
        className: "clue-lock-badge"
      }, m("i", {
        className: "fas fa-lock"
      }), " Pista ", idx + 1) : m("span", {
        className: "clue-unlocked-badge"
      }, m("i", {
        className: "fas fa-check"
      }), " Desbloqueada")), m("div", {
        className: "clue-body"
      }, isRevealed ? m("span", {
        className: "clue-value-text"
      }, clue.value) : m("span", {
        className: "clue-locked-placeholder"
      }, "Bloqueada \u2014 Si fallas o pides pista se desbloquear\xE1 (", pointsAfterThis, " pts m\xE1x)")));
    })), currentState.feedbackAlert && m("div", {
      className: "guess-feedback-alert alert-".concat(currentState.feedbackAlert.type)
    }, m("i", {
      className: "alert-icon fas ".concat(currentState.feedbackAlert.type === 'success' ? 'fa-check-circle' : currentState.feedbackAlert.type === 'error' ? 'fa-times-circle' : 'fa-info-circle')
    }), m("span", {
      className: "alert-text"
    }, currentState.feedbackAlert.message)), currentState.attempts.length > 0 && m("div", {
      className: "attempts-history-box"
    }, m("span", {
      className: "attempts-history-title"
    }, m("i", {
      className: "fas fa-history"
    }), " Intentos realizados (", currentState.attempts.length, "):"), m("div", {
      className: "attempts-chips-list"
    }, currentState.attempts.map((att, aIdx) => m("span", {
      key: aIdx,
      className: "attempt-chip ".concat(att.is_correct ? 'is-correct' : 'is-wrong')
    }, m("span", {
      className: "chip-icon"
    }, att.is_correct ? '✅' : '❌'), m("span", {
      className: "chip-name"
    }, att.name), m("span", {
      className: "chip-clue"
    }, "Pista ", att.clue_number))))), !currentState.isAnswered ? m("div", {
      className: "answer-section"
    }, m("label", {
      className: "answer-label"
    }, m("i", {
      className: "fas fa-search"
    }), " \xBFQui\xE9n crees que es? Elige tu candidato:"), m("div", {
      className: "autocomplete-wrapper"
    }, m("input", {
      type: "text",
      className: "FormControl autocomplete-input",
      placeholder: "Escribe el nombre del jugador (ej: Vivian, Sancet, Sim\xF3n...)",
      value: currentState.searchQuery,
      onfocus: () => {
        currentState.dropdownOpen = true;
        m.redraw();
      },
      oninput: e => {
        currentState.searchQuery = e.target.value;
        currentState.selectedCandidate = null;
        currentState.dropdownOpen = true;
      },
      onkeydown: e => {
        if (e.key === 'Enter' && currentState.selectedCandidate) {
          this.tryGuess();
        }
      }
    }), currentState.selectedCandidate && m("button", {
      type: "button",
      className: "btn-clear-selection",
      onclick: () => {
        currentState.selectedCandidate = null;
        currentState.searchQuery = '';
        currentState.dropdownOpen = true;
        m.redraw();
      },
      title: "Borrar selecci\xF3n"
    }, m("i", {
      className: "fas fa-times"
    })), currentState.dropdownOpen && filteredCandidates.length > 0 && m("div", {
      className: "autocomplete-dropdown"
    }, filteredCandidates.map(c => m("div", {
      key: c.id,
      className: "candidate-option ".concat(currentState.selectedCandidate && currentState.selectedCandidate.id === c.id ? 'is-selected' : ''),
      onclick: () => this.selectCandidate(c)
    }, c.photo_url ? m("img", {
      src: c.photo_url,
      alt: c.name,
      className: "candidate-avatar",
      style: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        objectFit: 'cover'
      }
    }) : m("span", {
      className: "candidate-avatar candidate-avatar--placeholder"
    }, "\uD83E\uDD81"), m("span", {
      className: "candidate-name"
    }, c.name), c.number > 0 && m("span", {
      className: "candidate-number"
    }, "#", c.number))))), m("div", {
      className: "guess-actions-bar"
    }, currentState.cluesRevealed < 5 && m("button", {
      type: "button",
      className: "btn-reveal-clue",
      onclick: () => this.revealNextClue()
    }, m("i", {
      className: "fas fa-unlock-alt"
    }), m("span", null, "Pedir pista ", currentState.cluesRevealed + 1, " sin probar (", NorDaLehoiaGame.POINTS_MAP[currentState.cluesRevealed + 1], " pts m\xE1x)")), m(Button, {
      className: "Button Button--primary btn-confirm-guess",
      icon: "fas fa-paper-plane",
      disabled: !currentState.selectedCandidate,
      onclick: () => this.tryGuess()
    }, "Probar Le\xF3n (", currentPoints, " pts)"))) : m("div", {
      className: "answered-navigation-box"
    }, !allDone ? m(Button, {
      className: "Button Button--primary btn-next-pending",
      icon: "fas fa-arrow-right",
      onclick: () => this.goToNextPending()
    }, "Ir al siguiente le\xF3n pendiente \uD83D\uDC49") : m(Button, {
      className: "Button Button--primary btn-finish-round",
      icon: "fas fa-flag-checkered",
      loading: this.submitting,
      onclick: () => this.submitRound()
    }, "Finalizar tanda y ver puntuaci\xF3n \uD83C\uDFC1"))), m("div", {
      className: "game-footer-bar"
    }, !currentState.isAnswered ? m(Button, {
      className: "Button Button--link btn-skip-match",
      icon: "fas fa-forward",
      onclick: () => this.skipCurrentPlayer()
    }, "Pasar le\xF3n (responder luego)") : m("div", null), m("div", {
      className: "footer-right-actions"
    }, m("span", {
      className: "answered-counter"
    }, answeredCount, " de ", this.items.length, " resueltos"), allDone ? m(Button, {
      className: "Button Button--primary btn-finish-round",
      icon: "fas fa-flag-checkered",
      loading: this.submitting,
      onclick: () => this.submitRound()
    }, "Finalizar Tanda") : m(Button, {
      className: "Button Button--secondary",
      icon: "fas fa-arrow-right",
      onclick: () => {
        const nextIdx = this.findNextPendingOrSkippedIndex(this.currentIndex);
        if (nextIdx !== -1) {
          this.currentIndex = nextIdx;
        } else {
          this.currentIndex = (this.currentIndex + 1) % this.items.length;
        }
        m.redraw();
      }
    }, "Siguiente"))));
  }
  renderResults() {
    const r = this.results || {};
    const score = r.score || 0;
    const correctCount = r.correct_count || 0;
    const totalItems = r.total_items || 5;
    const durationSec = r.duration_seconds || this.timerSeconds;
    const isPerfect = Boolean(r.is_perfect);
    const recordUpdated = Boolean(r.record_updated);
    const items = r.results || [];
    const isLoggedIn = Boolean(app.session.user);
    return m("div", {
      className: "nor-da-lehoia-game results-screen"
    }, m("div", {
      className: "results-summary-card"
    }, isPerfect && m("div", {
      className: "perfect-banner"
    }, m("span", {
      className: "celebration-emoji"
    }, "\uD83E\uDD81\uD83D\uDC51"), m("h3", null, "\xA1PLENO ZURIGORRI!"), m("p", null, "\xA15 de 5 leones acertados! Eres un aut\xE9ntico ojeador de Lezama.")), m("div", {
      className: "score-hero"
    }, m("div", {
      className: "score-circle"
    }, m("span", {
      className: "score-val"
    }, score), m("span", {
      className: "score-lbl"
    }, "Puntos"))), m("div", {
      className: "stats-row"
    }, m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, correctCount, " / ", totalItems), m("span", {
      className: "stat-label"
    }, "Aciertos")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, this.formatTimer(durationSec)), m("span", {
      className: "stat-label"
    }, "Tiempo")), m("div", {
      className: "stat-box"
    }, m("span", {
      className: "stat-num"
    }, r.high_score || score), m("span", {
      className: "stat-label"
    }, "Tu R\xE9cord"))), recordUpdated && m("div", {
      className: "record-badge"
    }, m("i", {
      className: "fas fa-trophy"
    }), " \xA1Nuevo r\xE9cord personal en Nor da Lehoia!"), !isLoggedIn && m("div", {
      className: "guest-warning"
    }, m("p", null, "Inicia sesi\xF3n o reg\xEDstrate para que tu puntuaci\xF3n compute en la clasificaci\xF3n general de Pasatiempos."), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-sign-in-alt",
      onclick: () => app.modal.show(LogInModal)
    }, "Iniciar Sesi\xF3n")), m("div", {
      className: "results-actions"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-redo",
      onclick: () => this.fetchNewRound()
    }, "Jugar Otra Tanda"))), m("div", {
      className: "results-matches-list"
    }, m("h4", null, "Desglose de Leones e Intentos"), m("div", {
      className: "review-cards-grid"
    }, items.map((item, i) => {
      const isOk = Boolean(item.is_correct);
      const attemptsList = item.attempts || [];
      return m("div", {
        key: item.key || i,
        className: "review-card ".concat(isOk ? 'is-correct' : 'is-wrong')
      }, m("div", {
        className: "review-photo-wrapper"
      }, item.correct_photo_url ? m("img", {
        src: item.correct_photo_url,
        alt: item.correct_player_name,
        className: "review-player-img",
        style: {
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          objectFit: 'cover'
        }
      }) : m("div", {
        className: "review-player-placeholder"
      }, "\uD83E\uDD81")), m("div", {
        className: "review-card-body"
      }, m("div", {
        className: "review-player-header"
      }, m("strong", null, "Le\xF3n ", i + 1, ": ", item.correct_player_name), m("span", {
        className: "status-pill ".concat(isOk ? 'correct' : 'wrong')
      }, isOk ? "+".concat(item.points, " pts (").concat(item.clues_used, " pistas)") : '0 pts')), m("div", {
        className: "review-attempts-history"
      }, m("span", {
        className: "attempts-label"
      }, m("i", {
        className: "fas fa-history"
      }), " Intentos (", attemptsList.length, "):"), attemptsList.length > 0 ? m("div", {
        className: "attempts-chips-row"
      }, attemptsList.map((att, aIdx) => m("span", {
        key: aIdx,
        className: "review-attempt-badge ".concat(att.is_correct ? 'correct' : 'wrong')
      }, att.is_correct ? '✅' : '❌', " ", att.name, " ", m("small", null, "(Pista ", att.clue_number, ")")))) : m("span", {
        className: "no-attempts-text"
      }, "Sin intentos")), m("div", {
        className: "review-clues-summary"
      }, item.clues.map((c, cIdx) => m("span", {
        key: cIdx,
        className: "clue-tag"
      }, c.label.split(' ')[0], " ", c.value)))));
    }))), m("div", {
      className: "results-leaderboard-section"
    }, m("h4", null, "\uD83C\uDFC6 Top Foreros en Nor da Lehoia?"), m(PasatiemposLeaderboard, {
      initialFilter: "nor_da_lehoia",
      hideFilters: true,
      compact: true,
      maxItems: 10
    })));
  }
}
// Points map by clues revealed
_defineProperty(NorDaLehoiaGame, "POINTS_MAP", {
  1: 200,
  2: 150,
  3: 100,
  4: 70,
  5: 40
});
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/NorDaLehoiaGame', NorDaLehoiaGame);